import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ExtensionType, extensions } from '@pixi/extensions';
import { UPDATE_PRIORITY } from './const.mjs';
import { Ticker } from './Ticker.mjs';
var TickerPlugin = /*#__PURE__*/function () {
  function TickerPlugin() {
    _classCallCheck(this, TickerPlugin);
  }
  _createClass(TickerPlugin, null, [{
    key: "init",
    value: function init(options) {
      var _this = this;
      options = Object.assign({
        autoStart: true,
        sharedTicker: false
      }, options);
      Object.defineProperty(this, "ticker", {
        set: function set(ticker) {
          if (this._ticker) {
            this._ticker.remove(this.render, this);
          }
          this._ticker = ticker;
          if (ticker) {
            ticker.add(this.render, this, UPDATE_PRIORITY.LOW);
          }
        },
        get: function get() {
          return this._ticker;
        }
      });
      this.stop = function () {
        _this._ticker.stop();
      };
      this.start = function () {
        _this._ticker.start();
      };
      this._ticker = null;
      this.ticker = options.sharedTicker ? Ticker.shared : new Ticker();
      if (options.autoStart) {
        this.start();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this._ticker) {
        var oldTicker = this._ticker;
        this.ticker = null;
        oldTicker.destroy();
      }
    }
  }]);
  return TickerPlugin;
}();
TickerPlugin.extension = ExtensionType.Application;
extensions.add(TickerPlugin);
export { TickerPlugin };